import React from 'react';
import Select, { StylesConfig } from 'react-select';

const errorColor = '#cc433c';
const gray3Color = '#e9edf3';

export interface SelectInputFieldProps {
  options: Array<any>;
  defaultValue?: DefaultValue;
  className?: string;
  classNamePrefix?: string;
  placeholder?: string;
  noOptionsMessage?: (any) => '';
  isSearchable?: boolean;
  isDisabled?: boolean;
  isClearable?: boolean;
  onChange?: (value: any) => void;
  isMulti?: boolean;
  closeMenuOnSelect?: boolean;
  hideSelectedOptions?: boolean;
  'aria-label'?: string;
  styles?: StylesConfig;
  hasError: boolean;
  value?: DefaultValue | undefined;
}

interface DefaultValue {
  label: string | number;
  value: string | number;
}

export const BaseSelect = (props: SelectInputFieldProps): React.ReactElement => {
  const defaultStyles: StylesConfig = {
    container: (styles, state) => ({
      width: 200,
      minWidth: 200,
      fontSize: '14px',
      fontWeight: 'normal',
      borderRadius: '4px',
      border: '1px solid',
      borderColor: props.hasError ? errorColor : gray3Color,
      boxShadow: state.isFocused ? '0 0 0 0.2rem #f1ecf0' : ['none'],
      ...styles,
    }),
    control: styles => ({ ...styles, border: 0, boxShadow: ['none'] }),
  };

  // Merge default styles with any custom styles passed as prop
  const combinedStyles: StylesConfig = {
    ...defaultStyles,
    ...props.styles,
  };
  return <Select styles={combinedStyles} {...props} />;
};

export const customSelectStyles = {
  input: (provided, state) => ({
    ...provided,
    width: state.isFocused ? provided.width : '0px',
    padding: state.isFocused ? provided.padding : '0px',
    margin: state.isFocused ? provided.margin : '0px',
  }),
};
